import { combineAuth } from './hr-authority';
import {HrCommonReadableAuthority} from "./hr-common-readable-authority";

export class OrganizationReadableAuthority extends HrCommonReadableAuthority {

    public static readonly MY_BASE = "organization";

    constructor(authority: string) {
        super(combineAuth(OrganizationReadableAuthority.MY_BASE, authority));
    }

}
